/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgActions = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 2v2.126a4.001 4.001 0 0 1 1.19 7.222L15.882 16H18v2h-1.391l1.33 3.658-1.879.683L14.481 18H9.518L7.94 22.341l-1.88-.683L7.39 18H6v-2h2.117l1.693-4.652A3.997 3.997 0 0 1 8.005 8.2L8 8a4.001 4.001 0 0 1 3-3.874V2zm-.704 9.99a4.058 4.058 0 0 1-.592 0L10.245 16h3.509zM12 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgActions as Actions };
